import React from 'react';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';

import {EntityCreatingCard} from '../index';

import {LocalForwardingEditForm} from '../../containers/index';

function LocalForwardingCreating(props) {
  const {
    handleClickButtonCancel,
    handleClickButtonSave,
    isValidLocalForwardingInfo,
  } = props;

  return (
    <EntityCreatingCard
      title={I18n.t('campusPage.localForwardingsTab.createLocalForwarding')}
      handleClickButtonCancel={handleClickButtonCancel}
      handleClickButtonSave={handleClickButtonSave}
      isValidEntity={isValidLocalForwardingInfo}
      customCardClass="card_localForwardings"
      customCardContentClass="card__content_localForwardings"
      content={
        <LocalForwardingEditForm />
      }
    />
  );
}

LocalForwardingCreating.propTypes = {
  handleClickButtonCancel: PropTypes.func.isRequired,
  handleClickButtonSave: PropTypes.func.isRequired,
  isValidLocalForwardingInfo: PropTypes.bool.isRequired,
};

export default LocalForwardingCreating;
